import type { IJobChat } from '@quesmed/types/models';
import { formatDateFromUnix } from '@/utils/date';

type ChatMessageProps = {
  chat: IJobChat;
  currentUserId: number;
};

export const Chat = ({ chat, currentUserId }: ChatMessageProps) => {
  if (chat.user.id === currentUserId) {
    // Right side (current user)
    return (
      <div className='flex items-start gap-2 justify-end'>
        <div className='text-right'>
          <div className='flex items-center gap-2 justify-end'>
            <span className='font-medium text-xs text-default-900'>{chat.user.firstName}</span>
            <span className='text-xs text-default-400'>
              {formatDateFromUnix(chat.createdAt as number, 'HH:mm')}
            </span>
          </div>
          <div className='bg-cyan-100 dark:bg-cyan-900 rounded-lg px-3 py-2 mt-1 text-sm text-default-800 xl:max-w-[15rem] 2xl:max-w-xs ml-auto'>
            {chat.message}
          </div>
        </div>
        {/* <div className='flex-shrink-0 w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-xs font-bold text-default-800'>
          {message.initials}
        </div> */}
      </div>
    );
  }
  // Left side (other user)
  return (
    <div className='flex items-start gap-2'>
      {/* <div className='flex-shrink-0 w-8 h-8 rounded-full bg-default-200 flex items-center justify-center text-xs font-bold text-default-600'>
        {message.initials}
      </div> */}
      <div>
        <div className='flex items-center gap-2'>
          <span className='font-medium text-xs text-default-900'>{chat.user.firstName}</span>
          <span className='text-xs text-default-400'>
            {formatDateFromUnix(chat.createdAt as number, 'HH:mm')}
          </span>
        </div>
        <div className='bg-lime-100 dark:bg-lime-900 rounded-lg px-3 py-2 mt-1 text-sm text-default-800 xl:max-w-[15rem] 2xl:max-w-xs'>
          {chat.message}
        </div>
      </div>
    </div>
  );
};
